module.exports = __webpack_public_path__ + "static/img/ic_fp_a.61a6b98.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/personCenter/images/ic_fp_a.png
// module id = Mrwz
// module chunks = 21